import { render, staticRenderFns } from "./CompanyDetail.vue?vue&type=template&id=7ba38de4&scoped=true"
import script from "./CompanyDetail.vue?vue&type=script&lang=js"
export * from "./CompanyDetail.vue?vue&type=script&lang=js"
import style0 from "./CompanyDetail.vue?vue&type=style&index=0&id=7ba38de4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba38de4",
  null
  
)

export default component.exports